(function () {
	function init() {
		document.addEventListener('click', click);
	}
	
	function click(event) {
		if (!util.hasClass(event.target, 'js-dropdown-menu-toggle-button')) {
			return;
		}
		
		const _target = document.getElementById(event.target.getAttribute('aria-controls'));
		
		util.toggleClass(_target, 'is-visible');
		
		if (util.hasClass(_target, 'is-visible')) {
			_target.setAttribute('aria-hidden', 'false');
			event.target.setAttribute('aria-expanded', 'true');
		} else {
			_target.setAttribute('aria-hidden', 'true');
			event.target.setAttribute('aria-expanded', 'false');
		}
	}
	
	init();
}());